import axios from "axios";

export const config = {
  baseURL: "https://ilift-backend.herokuapp.com",
  // baseURL: "http://localhost:8000",
};

export const http = axios.create({
  baseURL: config.baseURL,
});

export const roles = {
  1: 'ADMIN',
  2: 'DISPATCHER',
  3: 'FINANCE',
  4: 'CORPORATE',
};

export const homepages = role => {
  switch (role) {
    case 1:
      return "/dashboard";
    case 2:
      return "/manual-ride-booking";
    case 3:
      return "/finance";
    case 4:
      return "/corporate/dashboard";
    default:
      return "/dashboard";
  }
};
